export enum RadarDetectionType {
  ENDPOINT = 'ENDPOINT',
  DEPENDENCY = 'DEPENDENCY',
  SERVICE = 'SERVICE',
  ENVIRONMENT = 'ENVIRONMENT',
}
